import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b68a18a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filelist" }
const _hoisted_2 = ["src"]

import { ref } from 'vue'
import { EyeOutlined, FilePdfOutlined, WarningTwoTone } from '@ant-design/icons-vue'
import { authStore } from '@/stores/auth'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'Filelist',
  props: {
  mediaItems: Array,
  tenantId: Number
},
  setup(__props) {

const props = __props

const auth = authStore()



const showPreviewModal = ref(false)
// eslint-disable-next-line camelcase
const file:{ value:{ id:number, type:string, file_name:string, size: string, url:string }|null } = ref(null)

// eslint-disable-next-line camelcase
function togglePreviewModal (fileToPreview:{ id:number, type:string, file_name:string, size: string, url:string, important_media:{ id:number, tenant_id:number }[] }|null) : void {
  if (!showPreviewModal.value && fileToPreview) {
    if (fileToPreview.type === 'application/pdf') {
      window.open(fileToPreview.url, '_blank')
    } else {
      file.value = fileToPreview
      showPreviewModal.value = true
    }
    markAsRead(fileToPreview)
  } else {
    file.value = null
    showPreviewModal.value = false
  }
}

function checkIfImportantFile (file:{ id:number, type:string, file_name:string, size: string, url:string, important_media:{ id:number, tenant_id:number, read_at:boolean }[] }) : boolean {
  let isImportantFile = false

  if (props.tenantId !== undefined && file.important_media && file.important_media.length) {
    file.important_media.forEach((im:{ id:number, tenant_id:number, read_at:boolean }) => {
      if (props.tenantId === im.tenant_id && !im.read_at) {
        isImportantFile = true
      }
    })
  }

  return isImportantFile
}

function markAsRead (file:{ id:number, type:string, file_name:string, size: string, url:string, important_media:{ id:number, tenant_id:number }[] }) : void {
  if (props.tenantId !== undefined && file.important_media && file.important_media.length) {
    file.important_media.forEach((im:{ id:number, tenant_id:number }) => {
      if (auth.user.tenant_ids.includes(im.tenant_id)) {
        axios.post(process.env.VUE_APP_API_URL + '/importantMedia/' + im.id + '/read')
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_list, {
      "item-layout": "horizontal",
      "data-source": __props.mediaItems,
      size: "small"
    }, {
      renderItem: _withCtx(({ item }) => [
        _createVNode(_component_a_list_item, null, {
          actions: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_a_button, {
                onClick: ($event: any) => (togglePreviewModal(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EyeOutlined))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_list_item_meta, {
              class: "clickable",
              description: item.size,
              style: {"font-weight":"500","line-break":"anywhere"}
            }, {
              avatar: _withCtx(() => [
                (item.type === 'application/pdf')
                  ? (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 0,
                      class: "clickable",
                      shape: "square",
                      style: _normalizeStyle([{ backgroundColor: '#f38929' }, {"font-size":"18px"}]),
                      onClick: ($event: any) => (togglePreviewModal(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FilePdfOutlined))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 1,
                      class: "clickable",
                      shape: "square",
                      src: item.url,
                      onClick: ($event: any) => (togglePreviewModal(item))
                    }, null, 8, ["src", "onClick"]))
              ]),
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.file_name) + " ", 1),
                _createVNode(_component_a_tooltip, { title: "Belangrijk ongelezen document!" }, {
                  default: _withCtx(() => [
                    (checkIfImportantFile(item))
                      ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                          key: 0,
                          "two-tone-color": "#f38929",
                          style: {"margin-left":"8px"}
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["description"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data-source"]),
    (file.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          title: file.value.file_name,
          footer: null,
          visible: showPreviewModal.value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (togglePreviewModal(null)))
        }, {
          default: _withCtx(() => [
            (file.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: file.value.url,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})